import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

export const OtpProtectedRoute = ({ children }) => {
  const user = useSelector((state) => state?.user?.user);
  const hasAnyVerification = (user?.email_verified_at || user?.phone_number_verified_at) ? true : false;

  useEffect(()=>{
    window.scrollTo(0, 0);
  },[]);

  if (!user) {
    return <Navigate to="/signin" />;
  }

  if (hasAnyVerification) {
    return <Navigate to="/dashboard" />;
  }

  return children;
};